import React from "react";
import "./TextLong.css";

export default function TextLong({ textLong, isMobile }) {
    const width = window.innerWidth;

    const processParagraph = (paragraph) => {
        const splitForOpeningTag = paragraph.split("<");

        const processNoTag = (seg) => {
            const splitForClosingTag = seg.split(">");
            return splitForClosingTag.length > 1
                ? splitForClosingTag[1]
                : splitForClosingTag[0];
        };

        const tagToComponent = {
            h: "text-long-highlight",
            t: "text-title",
            q: "text-quote",
            s: "text-long-space",
            b: "text-long-bold",
            i: "text-long-italic",
            wh: "text-long-white",
            l: (content) => (
                <a
                    className="text-long-link"
                    rel="noreferrer"
                    href={content.split("(")[1].split(")")[0]}
                    target="_blank"
                >
                    {content.split("(")[0]}
                </a>
            ),
        };

        const processTag = (seg) => {
            const [tag, content] = seg.split(">");

            if (tag in tagToComponent) {
                const TagComponent = tagToComponent[tag];
                if (typeof TagComponent === "function") {
                    return TagComponent(content);
                }
                return <span className={TagComponent}>{content}</span>;
            }
            return content;
        };

        const paragraphClass = isMobile ? "text-long-mobile" : "text-long";
        return (
            <p className={paragraphClass}>
                {splitForOpeningTag.map((s, i) =>
                    i % 2 === 0 ? processNoTag(s) : processTag(s)
                )}
            </p>
        );
    };

    return (
        <div
            style={{
                backgroundColor: "black",
                padding: width >= 900 ? "0vh 25vw 0vh 25vw" : "0vh 10vw 0vh 10vw",
                textAlign: "left",
                overflow: "hidden",
            }}
        >
            {textLong.split("\r\n\r\n").map(processParagraph)}
        </div>
    );
}
